// @ts-nocheck

import { Box, Button, IconButton, Link, Paper, Typography } from '@material-ui/core'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { Check, X } from 'react-feather'
import { useTranslation } from 'react-i18next'

import noDataImage from '../../../../../assets/images/no-program.svg'
import { noop } from '../../../../../helpers/utils'
import CustomDialog from '../../../../common/CustomDialog'

function AddOnPurchaseItems({
  open,
  onClose,
  addOnsList,
  selectedAddOnItems,
  setSelectedAddOnItems,
  onProceed,
}) {
  const { t } = useTranslation()
  const [showMore, setShowMore] = React.useState<string[]>([])
  const onCheck = (event) => {
    if (Array.isArray(event)) {
      return setSelectedAddOnItems(event.map((item) => item))
    }
    const id = event.currentTarget.attributes['data-id'].value
    if (selectedAddOnItems.includes(id)) {
      setSelectedAddOnItems(selectedAddOnItems.filter((item) => item !== id))
    } else {
      setSelectedAddOnItems((oldState) => [...oldState, id])
    }
  }

  const reset = () => {
    setSelectedAddOnItems([])
  }

  const moreTextHandler = (id) => {
    if (showMore.includes(id)) {
      const tempShowMore = showMore.filter((showId) => showId !== id)
      setShowMore(tempShowMore)
    } else {
      setShowMore([...showMore, id])
    }
  }

  return (
    <CustomDialog
      paper="true"
      className="custom-dialog"
      close={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      fullWidth={true}
      maxWidth="md"
    >
      <DialogTitle disableTypography id="customized-dialog-title" onClose={onClose}>
        <Typography variant="h5" tabIndex={0}>
          <Box pt={1} fontWeight={700}>
            {t('addOnPurchase')}
          </Box>
          {onClose ? (
            <IconButton tabIndex={-1} aria-label="close" className="close-button" onClick={onClose}>
              <X />
            </IconButton>
          ) : null}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Paper rounded="true" elevation={1} className="paper-round">
          {addOnsList.length === 0 ? (
            <Box
              p={5}
              dispaly="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              width="100%"
            >
              <Box mb={3} display="flex" justifyContent="center" className="no-data-image">
                <img width="200px" src={noDataImage} alt="no data" />
              </Box>
              <Box
                component="p"
                fontSize="22px"
                fontWeight="600"
                align="center"
                className="custom-table-no-data"
              >
                {t('noAddOnServiceFound')}
              </Box>
            </Box>
          ) : null}
          <Box p={{ xs: 0, sm: 2 }}>
            <>
              {addOnsList?.map((row) => {
                return (
                  <Box
                    className={clsx('program-list  announcement-list custom-accordion', {
                      selected: selectedAddOnItems?.includes(row.aop_id.toString()),
                    })}
                    py={2}
                    px={2}
                    display="flex"
                    alignItems={{ xs: 'flex-start', sm: 'center' }}
                    justifyContent="space-between"
                    flexDirection={{ xs: 'column', sm: 'row' }}
                    key={row.aop_id}
                  >
                    <Box component="span" mr={1}>
                      <Typography component="h4" variant="body1" tabIndex={0}>
                        <Box className="text-primary" fontWeight={600}>
                          {row?.aop_name}
                        </Box>
                      </Typography>
                      <Typography
                        component="h6"
                        align="left"
                        variant="subtitle2"
                        color="textPrimary"
                      >
                        <Box component="div" fontSize={14} fontWeight={600}>
                          {t('with$', {
                            amount: row?.aop_amount,
                          })}
                        </Box>
                      </Typography>

                      <Typography
                        component="h6"
                        align="left"
                        variant="subtitle2"
                        color="textPrimary"
                      >
                        <Box component="span" fontWeight="fontWeightMedium" fontSize="12px">
                          {showMore.includes(row.aop_id)
                            ? row.aop_description
                            : `${row?.aop_description?.slice(0, 300)}`}
                          {!showMore.includes(row.aop_id)
                            ? row?.aop_description?.length >= '300'
                              ? '...'
                              : ''
                            : ''}
                          {row?.aop_description?.length >= '300' && (
                            <Box component="span" fontWeight="fontWeightBold" ml={1}>
                              <Link
                                className="text-info cursor-pointer"
                                component="a"
                                onClick={() => moreTextHandler(row.aop_id)}
                                key={row.aop_id}
                              >
                                {t(showMore.includes(row.aop_id) ? 'lessDetails' : 'moreDetails')}
                              </Link>
                            </Box>
                          )}
                        </Box>
                      </Typography>
                    </Box>

                    <Box component="span" fontSize={16} fontWeight={600} minWidth="112px">
                      {selectedAddOnItems.includes(row.aop_id.toString()) ? (
                        <Button
                          className="custom-default-button text-transform-none"
                          variant="contained"
                          disableElevation
                          fullWidth
                          data-id={row.aop_id}
                          onClick={(event) => onCheck(event)}
                          startIcon={<Check width={16} height={16} />}
                        >
                          {t('selected')}
                        </Button>
                      ) : (
                        <Button
                          className="text-transform-none"
                          variant="contained"
                          color="primary"
                          disableElevation
                          fullWidth
                          data-id={row.aop_id}
                          onClick={(event) => onCheck(event)}
                        >
                          {t('select')}
                        </Button>
                      )}
                    </Box>
                  </Box>
                )
              })}
              <Box
                mt={{ xs: 1, sm: 0 }}
                display="flex"
                alignItems="center"
                justifyContent={{
                  xs: 'flex-end',
                  sm: 'flex-end',
                  md: 'space-between',
                }}
              >
                <Button
                  className={`text-transform-none `}
                  size="large"
                  variant="contained"
                  disableElevation
                  disabled={!selectedAddOnItems?.length}
                  onClick={() => reset()}
                >
                  {t('reset')}
                </Button>
                <Button
                  className="text-transform-none"
                  size="large"
                  variant="contained"
                  color="primary"
                  disableElevation
                  onClick={() => onProceed('proceedClick')}
                  // disabled={!selectedAddOnItems?.length}
                  style={{ minWidth: '128px' }}
                >
                  {t('proceed')}
                </Button>
              </Box>
            </>
          </Box>
        </Paper>
      </DialogContent>
    </CustomDialog>
  )
}

AddOnPurchaseItems.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  addOnsList: PropTypes.array,
  selectedAddOnItems: PropTypes.array,
  setSelectedAddOnItems: PropTypes.func,
  onProceed: PropTypes.func,
}

AddOnPurchaseItems.defaultProps = {
  open: false,
  onClose: noop,
  addOnsList: [],
  selectedAddOnItems: [],
  setSelectedAddOnItems: noop,
  onProceed: noop,
}

export default AddOnPurchaseItems
